// The screen's clock for TimeBlocker: the now line, what "today" is, and the
// time worked so far. It moves on at each turn of the minute and never asks
// the server.
import { useEffect, useState } from "react";

/** The time now, moved on at each turn of the minute. */
export function useMinuteClock(): Date {
  const [now, setNow] = useState(() => new Date());
  // frontend-development: not a fetch; the screen's clock (once a minute).
  useEffect(() => {
    let timer = 0;
    const tick = () => {
      setNow(new Date());
      timer = window.setTimeout(tick, 60_000 - (Date.now() % 60_000));
    };
    timer = window.setTimeout(tick, 60_000 - (Date.now() % 60_000));
    return () => window.clearTimeout(timer);
  }, []);
  return now;
}

/**
 * The seconds a running Block has run (ms, whole seconds), moved on at each
 * second of the Block's own run, so every display of it (the timeline, the
 * header, the detail, the menu bar) turns over together. 0 when `startedAt` is
 * null.
 */
export function useElapsedMs(startedAt: string | null): number {
  const start = startedAt === null ? null : new Date(startedAt).getTime();
  const [now, setNow] = useState(() => Date.now());
  // frontend-development: not a fetch; the clock of the running time shown.
  useEffect(() => {
    if (start === null) return;
    let timer = 0;
    const tick = () => {
      setNow(Date.now());
      timer = window.setTimeout(
        tick,
        1000 - ((((Date.now() - start) % 1000) + 1000) % 1000) + 5,
      );
    };
    tick();
    return () => window.clearTimeout(timer);
  }, [start]);
  return start === null
    ? 0
    : Math.max(0, Math.floor((now - start) / 1000) * 1000);
}
